import { createContext, useContext } from 'react';

const TabsContext = createContext({
    id: '',
    label: '',
    selectedTabIndex: 0,
    selectTabIndex() {
        throw new Error('TabsContext.selectTabIndex is not implemented.');
    },
});
const useTabs = () => useContext(TabsContext);

export { TabsContext, useTabs };
